var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "map-wrapper"
  }, [_c("div", {
    staticClass: "map-list"
  }, [_c("a-card", {
    staticClass: "darkBg",
    attrs: {
      title: "分布图 (点击可下钻到县)",
      hoverable: true,
      bordered: false
    }
  }, [_c("series-map", {
    staticClass: "chart-map"
  })], 1)], 1), _c("div", {
    staticClass: "map-list"
  }, [_c("a-card", {
    staticClass: "darkBg",
    attrs: {
      title: "散点图 (点击可下钻到县)",
      hoverable: true,
      bordered: false
    }
  }, [_c("scatter-map", {
    staticClass: "chart-map"
  })], 1)], 1), _c("div", {
    staticClass: "map-list"
  }, [_c("a-card", {
    staticClass: "darkBg",
    attrs: {
      title: "热力图",
      hoverable: true,
      bordered: false
    }
  }, [_c("hot-map", {
    staticClass: "chart-map"
  })], 1)], 1), _c("div", {
    staticClass: "map-list"
  }, [_c("a-card", {
    staticClass: "darkBg",
    attrs: {
      title: "航线图",
      hoverable: true,
      bordered: false
    }
  }, [_c("line-map", {
    staticClass: "chart-map"
  })], 1)], 1), _c("div", {
    staticClass: "map-list"
  }, [_c("a-card", {
    staticClass: "darkBg",
    attrs: {
      title: "时间轴地图",
      hoverable: true,
      bordered: false
    }
  }, [_c("time-map", {
    staticClass: "chart-map"
  })], 1)], 1)]);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };